import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=201b5eba&"
import script from "./AddRole.vue?vue&type=script&lang=ts&"
export * from "./AddRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports